import React from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog';
export const RemoveItemFromCartPopupComponent = ({
  open,
  onClose,
  onConfirm,
  message,
  item,
  isDraft,
  cartItemBoxItemItself,
  isRemoveFromBox,
  params
}) => /*#__PURE__*/React.createElement(ConfirmDialog, {
  open: open,
  onCancel: onClose,
  onConfirm: () => onConfirm(item, isDraft, cartItemBoxItemItself, params.itemIdFromReorder, isRemoveFromBox),
  msg: message
});